<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form">
        <v-row dense>
          <v-col cols="12" md="3">
            <v-select
              v-model="type"
              :items="typeList"
              label="Loại phiếu"
              outlined
              dense
              clearable
              hide-details
              placeholder="Tất cả loại phiếu"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="date"
              type="date"
              label="Ngày thực hiện"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="title"
              label="Mã phiếu hoặc tiêu đề"
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { textHelpers } from '@/helpers/TextHelper'

export default {
  name: 'TransactionFilter',
  data: () => ({
    type: '',
    date: null,
    title: '',
    typeList: [
      { text: 'Nhập kho', value: 'IMPORT' },
      { text: 'Xuất kho', value: 'EXPORT' },
      { text: 'Luân chuyển vị trí', value: 'TRANSFER' },
      { text: 'Thanh lý', value: 'LIQUIDATION' }
    ]
  }),
  mounted() {
    this.onFilterChanged()
  },
  methods: {
    onFilterChanged() {
      const params = {}
      if (this.type) params.type = this.type
      if (this.date) params.transactionDate = this.date
      if (this.title) params.title_contains = textHelpers.removeSpaces(this.title)
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;
  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
